import { IDot } from 'models/ICattlesData'
import moment from 'moment'

export const MAX_MONTHLY_CHART_POINTS = 12

type DateRange = {
	startDate: number
	endDate: number
}

export const isDateRangeLongerThanMonths = (
	dateRange: DateRange,
	months: number,
) => {
	const startDate = moment(dateRange.startDate).startOf('day')
	const endDate = moment(dateRange.endDate).endOf('day')
	const threshold = startDate.clone().add(months, 'months').endOf('day')

	return endDate.isAfter(threshold)
}

const aggregateDotsByMonth = (
	dots: IDot[],
	mode: 'average' | 'sum',
	maxPoints = MAX_MONTHLY_CHART_POINTS,
): IDot[] => {
	const monthlyData = new Map<
		string,
		{ sum: number; count: number; date_ms: number }
	>()

	dots.forEach(dot => {
		const date = moment(dot.date_ms ?? dot.date)
		if (!date.isValid() || !Number.isFinite(dot.value)) return

		const monthKey = date.format('YYYY-MM')
		const month = monthlyData.get(monthKey) ?? {
			sum: 0,
			count: 0,
			date_ms: date.clone().startOf('month').valueOf(),
		}

		month.sum += dot.value
		month.count += 1
		monthlyData.set(monthKey, month)
	})

	return Array.from(monthlyData.values())
		.sort((a, b) => a.date_ms - b.date_ms)
		.map(({ sum, count, date_ms }) => ({
			value: mode === 'average' ? Math.round(sum / count) : sum,
			date_ms,
		}))
		.slice(-maxPoints)
}

export const aggregateDotsByMonthAverage = (
	dots: IDot[],
	maxPoints = MAX_MONTHLY_CHART_POINTS,
): IDot[] => aggregateDotsByMonth(dots, 'average', maxPoints)

export const aggregateDotsByMonthSum = (
	dots: IDot[],
	maxPoints = MAX_MONTHLY_CHART_POINTS,
): IDot[] => aggregateDotsByMonth(dots, 'sum', maxPoints)
